module.exports = __webpack_public_path__ + "img/Ambee1.d8c64940.png";